import React, { useEffect, useRef, useState } from "react";

const beforeImage = 'https://d219vm0w05qayd.cloudfront.net/assets/benefits/left-1ebb9c5cf7f07569dbaf865f631d26a9b01d3dc868d1df4046d6c66cfee0fc6f.jpg';
const afterImage = 'https://d219vm0w05qayd.cloudfront.net/assets/benefits/right-e0a6a2d867ee39da549e96a6341217b36aa0c4e5e31c905f766940a985cfcfc5.jpg';

const BeforeAfterSlider = () => {
  const containerRef = useRef(null);
  const sliderRef = useRef(null);
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isSliding, setIsSliding] = useState(false);

  useEffect(() => {
    const container = containerRef.current;

    if (!container) return;

    const startSlide = (e) => {
      e.preventDefault();
      setIsSliding(true);
    };

    const endSlide = () => {
      setIsSliding(false);
    };

    const moveSlide = (e) => {
      if (!isSliding) return;

      const pos = getCursorPos(e);
      const containerWidth = container.offsetWidth;
      let percentage = (pos / containerWidth) * 100;

      // Clamp slider position to 0-100
      if (percentage < 0) percentage = 0;
      if (percentage > 100) percentage = 100;

      setSliderPosition(percentage);
    };

    const getCursorPos = (e) => {
      const rect = container.getBoundingClientRect();
      const x = e.pageX || e.touches[0].pageX;
      return x - rect.left - window.pageXOffset;
    };

    const slider = sliderRef.current;
    slider.addEventListener("mousedown", startSlide);
    slider.addEventListener("touchstart", startSlide);
    window.addEventListener("mousemove", moveSlide);
    window.addEventListener("touchmove", moveSlide);
    window.addEventListener("mouseup", endSlide);
    window.addEventListener("touchend", endSlide);

    return () => {
      slider.removeEventListener("mousedown", startSlide);
      slider.removeEventListener("touchstart", startSlide);
      window.removeEventListener("mousemove", moveSlide);
      window.removeEventListener("touchmove", moveSlide);
      window.removeEventListener("mouseup", endSlide);
      window.removeEventListener("touchend", endSlide);
    };
  }, [isSliding]);

  return (
    <div className="invislineSLider" style={{ textAlign: "center", fontFamily: "Outfit, sans-serif" }}>
      {/* Headings */}
      <h1
        style={{
          color: "#0047AB",
          fontFamily: "Outfit-SemiBold",
          marginBottom: "10px",
          fontSize:"47px"
        }}
      >
        Invisalign aligners
      </h1>
      <h1
        style={{
          color: "black",
          fontFamily: "Outfit-Light",
          marginBottom: "30px",
        }}
      >
        Virtually invisible, lifestyle friendly
      </h1>

      {/* Image Container */}
      <div
        ref={containerRef}
        style={{
          position: "relative",
          maxWidth: "400px",
          height: "400px",
          overflow: "hidden",
          margin: "0 auto",
          border: "2px solid rgb(72, 72, 72)",
          borderRadius: "50%",
        }}
      >
        {/* Before Image */}
        <img
          src={beforeImage}
          alt="Before"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />

        {/* After Image with clipping applied */}
        <img
          src={afterImage}
          alt="After"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            clipPath: `inset(0 ${100 - sliderPosition}% 0 0)`,
          }}
        />

        {/* Vertical Line */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: `${sliderPosition}%`,
            width: "2px",
            height: "100%",
            backgroundColor: "#0047AB",
            zIndex: 8,
            transform: "translateX(-50%)",
          }}
        ></div>

        {/* Slider */}
        <div
          ref={sliderRef}
          style={{
            position: "absolute",
            zIndex: 9,
            cursor: "ew-resize",
            width: "50px",
            height: "50px",
            backgroundColor: "#0047AB",
            opacity: 0.9,
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            border: "2px solid white",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
            left: `${sliderPosition}%`,
            top: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <span style={{ fontSize: "24px", color: "white" }}>↔</span>
        </div>
      </div>

      <h1
        style={{
          color: "#0047AB",
          fontFamily: "Outfit-Light",
          fontSize:"25px",
          paddingLeft:"5%",
          paddingRight:"5%",
          marginBottom: "30px",
        }}
      >
        Most people won't even notice you are wearing them
      </h1>
    </div>
  );
};

export default BeforeAfterSlider;
